import { render, staticRenderFns } from "./c_avatar.vue?vue&type=template&id=495240f4&scoped=true"
import script from "./c_avatar.vue?vue&type=script&lang=js"
export * from "./c_avatar.vue?vue&type=script&lang=js"
import style0 from "./c_avatar.vue?vue&type=style&index=0&id=495240f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495240f4",
  null
  
)

export default component.exports